/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react"
import { Row, Form, Button } from "react-bootstrap"
import Select from "react-select"
import ReactTable from "../ReactTable"
import { allTableColumns } from "./helpers/casesTableAllColumns"
import casesTableColumnConfig from "../../components/cases/helpers/casesTableColumnConfig"
import Case from "../../pages/case/index"
import { useAuthUserDetails } from "@apis/users/useUsers"
import useLocalStorage from "../../hooks/useLocalStorage"
import isEmpty from "lodash/isEmpty"
import { useDrawer } from "@contexts/DrawerContext"

const CasesTable = ({ cases, loadCases }) => {
  const { data: userInfo } = useAuthUserDetails()
  const roles = userInfo.roles || []
  const [columnViewChange, setColumnViewChange] = useLocalStorage(
    "column_view_change",
    [],
  )
  const [columnsToDisplay, setColumnsToDisplay] = useLocalStorage(
    "columns_to_display",
    casesTableColumnConfig(roles, columnViewChange),
  )
  const [showCaseDrawer, setShowCaseDrawer] = useState(null)
  const { openDrawer, open, closeDrawer } = useDrawer()

  useEffect(() => {
    setColumnsToDisplay(casesTableColumnConfig(roles, columnViewChange))
  }, [roles, columnViewChange])

  const columnOptions = () => {
    return allTableColumns.reduce((previousValue, currentValue) => {
      if (!columnsToDisplay.includes(currentValue)) {
        previousValue.push({
          label: currentValue.Header,
          value: currentValue.accessor,
        })
      }
      return previousValue
    }, [])
  }

  const resetColumnView = () => {
    setColumnViewChange([])
    setColumnsToDisplay(casesTableColumnConfig(roles, []))
  }

  useEffect(() => {
    if (showCaseDrawer === false && !open) {
      loadCases(true)
    }
  }, [closeDrawer])

  const handleShowCaseModal = (caseGuid) => {
    openDrawer(<>
      {caseGuid && <Case caseGuid={caseGuid} />}
    </>, "Case")
    setShowCaseDrawer(open)
  }

  return (
    <div data-testid="cases-table">
      <Row className="p-4">
        <h2>Cases</h2>
        <p>{cases.length} total cases</p>
        <ReactTable
          columns={columnsToDisplay}
          data={cases}
          handleClick={(e) => handleShowCaseModal(e.case_guid)}
          canHover={true}
        />
      </Row>
      <Row className="p-4">
        <Form.Label>Show Columns:</Form.Label>
        <Select
          aria-label="Columns Displayed"
          size="med"
          isMulti
          options={columnOptions()}
          onChange={(e) => setColumnViewChange(e)}
          value={columnsToDisplay.map((col) => ({
            label: col.Header,
            value: col.accessor,
          }))}
          theme={(theme) => ({
            ...theme,
            colors: {
              ...theme.colors,
              primary25: "#B0DBE9",
              primary: "#0E7C9E",
            },
          })}
        />
      </Row>
      <Row className="p-4">
        <Button
          className="btn btn-primary px-2"
          onClick={resetColumnView}
          disabled={isEmpty(columnViewChange)}
        >
          Reset Column View
        </Button>
      </Row>
    </div>
  )
}

export default CasesTable
